export const DecryptPayloadErrorResponse = {
    is: (error) => {
        if (typeof error === 'object' && error !== null && 'type' in error) {
            const { type } = error;
            if (type === 'parse_error' || type === 'no_matching_secrets') {
                return true;
            }
            if (type === 'missing_fields' &&
                'decrypted' in error &&
                'missing_fields' in error) {
                const { decrypted, missing_fields } = error;
                if (typeof decrypted === 'string' && Array.isArray(missing_fields)) {
                    return true;
                }
            }
        }
        return false;
    },
    mkErrorMessage: (error) => {
        switch (error.type) {
            case 'parse_error': {
                return { message: 'Parse error.' };
            }
            case 'no_matching_secrets': {
                return { message: 'No matching secrets.' };
            }
            case 'missing_fields': {
                const missingFields = error.missing_fields.join(', ');
                return {
                    message: `Missing fields: ${missingFields}.`,
                    decrypted: error.decrypted,
                };
            }
        }
    },
};
